// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let API = require("../reason/common/API.bs.js");
let ReasonPromise = require("../reason/ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let AuthSessionUserIdQuery_graphql = require("../__generated__/AuthSessionUserIdQuery_graphql.bs.js");
let AuthSessionUserRoleQuery_graphql = require("../__generated__/AuthSessionUserRoleQuery_graphql.bs.js");

let useCurrentAuthSession_ = {
  contents: () => {}
};

let getWithExpiryCheck_ = {
  contents: async param => {}
};

let logout_ = {
  contents: async () => {}
};

let loginSuccess_ = {
  contents: param => {}
};

let createSession_ = {
  contents: async () => {}
};

let Internal = {
  useCurrentAuthSession_: useCurrentAuthSession_,
  getWithExpiryCheck_: getWithExpiryCheck_,
  logout_: logout_,
  loginSuccess_: loginSuccess_,
  createSession_: createSession_
};

function use() {
  return useCurrentAuthSession_.contents();
}

function getWithExpiryCheck(operationName) {
  return getWithExpiryCheck_.contents(operationName);
}

function logout() {
  return logout_.contents();
}

function createSession() {
  return createSession_.contents();
}

let convertVariables = AuthSessionUserIdQuery_graphql.Internal.convertVariables;

let convertResponse = AuthSessionUserIdQuery_graphql.Internal.convertResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables, AuthSessionUserIdQuery_graphql.node, convertResponse);

RescriptRelay_Query.useLoader(convertVariables, AuthSessionUserIdQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(AuthSessionUserIdQuery_graphql.node, convertResponse, prim => prim);

RescriptRelay_Query.fetch_(AuthSessionUserIdQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.fetchPromised(AuthSessionUserIdQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.retain(AuthSessionUserIdQuery_graphql.node, convertVariables);

function useCurrentUserId() {
  let data = use$1(undefined, "store-only", undefined, undefined);
  let match = data.currentAuthSession;
  if (match !== undefined && match.__typename === "AuthSession") {
    return match.user.id;
  }
}

function useIsLoggedIn() {
  return Stdlib_Option.isSome(useCurrentUserId());
}

let convertVariables$1 = AuthSessionUserRoleQuery_graphql.Internal.convertVariables;

let convertResponse$1 = AuthSessionUserRoleQuery_graphql.Internal.convertResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables$1, AuthSessionUserRoleQuery_graphql.node, convertResponse$1);

RescriptRelay_Query.useLoader(convertVariables$1, AuthSessionUserRoleQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(AuthSessionUserRoleQuery_graphql.node, convertResponse$1, prim => prim);

RescriptRelay_Query.fetch_(AuthSessionUserRoleQuery_graphql.node, convertResponse$1, convertVariables$1);

RescriptRelay_Query.fetchPromised(AuthSessionUserRoleQuery_graphql.node, convertResponse$1, convertVariables$1);

RescriptRelay_Query.retain(AuthSessionUserRoleQuery_graphql.node, convertVariables$1);

function useCurrentUserRole() {
  let data = use$2(undefined, "store-only", undefined, undefined);
  let match = data.currentAuthSession;
  if (match !== undefined && match.__typename === "AuthSession") {
    return match.user.role;
  }
}

function login(email, password, rememberMeOpt) {
  let rememberMe = rememberMeOpt !== undefined ? rememberMeOpt : false;
  return ReasonPromise.Js.toBsPromise(ReasonPromise.map(API.login(email, password, rememberMe), x => {
    if (x.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: x._0
      };
    }
    let data = x._0;
    loginSuccess_.contents(data);
    return {
      TAG: "Ok",
      _0: data
    };
  }));
}

function useIsImpersonated() {
  let authSession = use();
  if (authSession !== undefined && authSession.__typename === "AuthSession") {
    return authSession.isImpersonated;
  } else {
    return false;
  }
}

function useAgentIsCurrentUser(agentId) {
  let authSession = use();
  if (authSession === undefined) {
    return false;
  }
  if (authSession.__typename !== "AuthSession") {
    return false;
  }
  let match = authSession.user;
  if (match.role === "AGENT" && agentId !== undefined) {
    return match.id === agentId;
  } else {
    return false;
  }
}

exports.Internal = Internal;
exports.use = use;
exports.getWithExpiryCheck = getWithExpiryCheck;
exports.logout = logout;
exports.createSession = createSession;
exports.useCurrentUserId = useCurrentUserId;
exports.useIsLoggedIn = useIsLoggedIn;
exports.useCurrentUserRole = useCurrentUserRole;
exports.login = login;
exports.useIsImpersonated = useIsImpersonated;
exports.useAgentIsCurrentUser = useAgentIsCurrentUser;
/* use Not a pure module */
